(function () {
  const initProductAccordion = () => {
		$(".about__accordion-toggle").click(function () {
			if (!$(this).hasClass("active")) {
				$(this).addClass("active");
				$(this)
					.siblings(".about__accordion-description")
					.eq($(this).index())
					.stop()
					.slideDown(300);
			} else {
				$(this).removeClass("active");
				$(this).siblings(".about__accordion-description").stop().slideUp(300);
			}
		});
  };

  const initCustomCursor = () => {
    const touchGallery = window.matchMedia('(max-width: 749px), (pointer: coarse)');
    // Never show a mouse cursor on touch devices or compact layouts.
    let cursor = document.querySelector('.product-zoom-cursor');
    if (!cursor) {
      cursor = document.createElement('div');
      cursor.className = 'product-zoom-cursor';
      document.body.appendChild(cursor);
    }

    // Get all zoom trigger elements
    const zoomTriggers = document.querySelectorAll('.product__media-toggle, .product-media-modal__content');

    // Mouse move handler
    const moveCursor = (e) => {
      cursor.style.left = e.clientX - 24 + 'px'; // Center the 48px cursor
      cursor.style.top = e.clientY - 24 + 'px';
    };

    // Add event listeners to zoom triggers
    zoomTriggers.forEach(trigger => {
      trigger.addEventListener('mouseenter', () => {
        cursor.classList.add('active');
        document.addEventListener('mousemove', moveCursor);
      });

      trigger.addEventListener('pointerleave', () => {
        cursor.classList.remove('active');
        document.removeEventListener('mousemove', moveCursor);
      });
    });
  };

  const initZoomImage = () => {
    document.querySelectorAll('product-modal').forEach(modal => {
      const stage = modal.querySelector('.product-media-modal__content');
      const toolbar = modal.querySelector('.jhny-media-toolbar');
      if (!stage || !toolbar || stage.dataset.jhnyZoomBound) return;
      stage.dataset.jhnyZoomBound = 'true';

      const touchGallery = window.matchMedia('(max-width: 749px), (pointer: coarse)');
      const zoomButton = toolbar.querySelector('[data-jhny-media-zoom]');
      const zoomLabel = toolbar.querySelector('[data-jhny-media-zoom-label]');
      const previous = toolbar.querySelector('[data-jhny-media-prev]');
      const next = toolbar.querySelector('[data-jhny-media-next]');
      const count = toolbar.querySelector('[data-jhny-media-count]');
      const slides = Array.from(stage.querySelectorAll('.product-media-modal__item'));
      let zoomed = false;
      let activeSlide = null;

      const fitImage = (center = false) => {
        const image = activeSlide?.querySelector('.js-image-zoom');
        if (!touchGallery.matches || !image || !image.naturalWidth || !stage.clientHeight) return;
        const scale = Math.min(
          Math.max(1, stage.clientWidth - 32) / image.naturalWidth,
          Math.max(1, stage.clientHeight - 24) / image.naturalHeight
        ) * (zoomed ? 1.75 : 1);
        image.style.setProperty('--jhny-image-width', image.naturalWidth * scale + 'px');
        image.style.setProperty('--jhny-image-height', image.naturalHeight * scale + 'px');
        if (center) requestAnimationFrame(() => {
          if (!activeSlide) return;
          activeSlide.scrollLeft = Math.max(0, (activeSlide.scrollWidth - activeSlide.clientWidth) / 2);
          activeSlide.scrollTop = Math.max(0, (activeSlide.scrollHeight - activeSlide.clientHeight) / 2);
        });
      };

      const setZoom = value => {
        zoomed = !!value && touchGallery.matches;
        stage.classList.toggle('jhny-zoomed', zoomed);
        stage.classList.remove('zoom');
        if (stage.swiper) stage.swiper.allowTouchMove = !zoomed;
        zoomButton.setAttribute('aria-pressed', String(zoomed));
        zoomLabel.textContent = zoomed ? 'Zoom out' : 'Zoom in';
        fitImage(true);
      };

      const sync = () => {
        const current = stage.querySelector('.swiper-slide-active') || slides[0];
        if (current !== activeSlide) {
          activeSlide = current;
          setZoom(false);
        }
        const index = slides.indexOf(current);
        previous.disabled = index <= 0;
        next.disabled = index >= slides.length - 1;
        zoomButton.disabled = !current?.querySelector('.js-image-zoom');
        count.textContent = (index + 1) + ' / ' + slides.length;
        fitImage();
      };

      zoomButton.addEventListener('click', () => setZoom(!zoomed));
      previous.addEventListener('click', () => {
        setZoom(false);
        stage.swiper?.slidePrev();
      });
      next.addEventListener('click', () => {
        setZoom(false);
        stage.swiper?.slideNext();
      });
      stage.querySelectorAll('.js-image-zoom').forEach(image => {
        image.addEventListener('load', () => fitImage(true));
        image.addEventListener('click', () => {
          if (!touchGallery.matches) stage.classList.toggle('zoom');
        });
      });
      new MutationObserver(sync).observe(stage.querySelector('.swiper-wrapper'), {
        attributes: true, attributeFilter: ['class'], subtree: true
      });
      new MutationObserver(() => {
        setZoom(false);
        sync();
      }).observe(modal, { attributes: true, attributeFilter: ['open'] });
      new ResizeObserver(() => fitImage(true)).observe(stage);
      touchGallery.addEventListener('change', () => { setZoom(false); sync(); });
      sync();
    });
  };

  document.addEventListener('shopify:section:load', function () {
    initProductAccordion();
    initZoomImage();
    initCustomCursor();
  });

  initProductAccordion();
  initZoomImage();
  initCustomCursor();
})();

